// extracted by mini-css-extract-plugin
export default {"modal":"bha-z","modalContent":"cha-z","footer":"dha-z","cancelBtn":"eha-z","disabled":"fha-z","formWrapper":"gha-z","fade":"hha-z","fade-in":"iha-z","iframe":"jha-z"};